// extracted by mini-css-extract-plugin
export default {"legend-icon":"JPAcBsO___legend-icon","legendIcon":"JPAcBsO___legend-icon"};